import classNames from 'classnames';
import React from 'react';
import Box from '@mui/material/Box';
import styles from './Status.module.scss';
import { Typography } from '@mui/material';

export type StatusProps = {
	status: string;
	className?: string;
	onClick?: ( event: React.MouseEvent<HTMLElement> ) => void;
	ref?: React.Ref<HTMLLIElement>;
};

export const Status: React.FC<StatusProps> = ( {
	status,
	className,
	onClick,
	ref,
} ) => {
	const statusClass = status.replace( / /g, '-' );

	return (
		<Box
			className={ classNames(
				styles[ 'mui-status' ],
				styles[ `mui-status--${ statusClass }` ],
				className
			) }
			onClick={ onClick }
			ref={ ref }
			data-cy='status'
		>
			<Typography className={ styles[ 'label' ] }>{ status }</Typography>
		</Box>
	);
};
